import PhosphorIcon from 'teacher-ui-client/components/phosphor-icon'

export const BreadcrumbSeparator = <template>
  <PhosphorIcon class="text-dusty-black-250 mx-2" @icon="phosphor-caret-right-bold" />
</template>

export default BreadcrumbSeparator
